'use client';

import Link from 'next/link';
import { CircleHelp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@kit/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@kit/ui/tooltip';

/**
 * "Need help" entry point in the fixed top bar (left of the account chip),
 * visible to every user (2026-07-05 chrome consolidation — it lived in the
 * sidebar footer before). Opens the standalone support page, which merges
 * the Flow AI first responder with human support.
 */
export function TopBarHelpButton() {
  const { t } = useTranslation();
  const label = t('home:headerActions.getHelp');

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            asChild
            variant="ghost"
            size="icon"
            aria-label={label}
            className="text-muted-foreground hover:text-foreground"
          >
            <Link href="/home/support">
              <CircleHelp className="size-5" />
            </Link>
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
